/**
 * Round a date to the nearest X milliseconds.
 * @param date         Original date.
 * @param milliseconds Interval to round to.
 * @returns            Rounded date.
 */
export const roundDownToInterval = (date: Date, milliseconds: number) => {
    return new Date(Math.floor(date.getTime() / milliseconds) * milliseconds);
};
